import css from '../../../utils/css';

const disclaimer = css`
  [name='disclaimer'] > footer {
    background: var(--ogm-grid-main-bg-color);
    border: 1px solid var(--ogm-grid-main-border-color);
    border-radius: 5px;
    color: var(--ogm-text-body);
    padding: 12px 30px 11px 20px;
    margin-top: 0;
  }

  slot[name='footer-notice'],
  slot[name='footer-notice'] > a,
  .footer__icons > div {
    font-family: var(--ogm-font-family-1);
    font-size: 10px;
  }

  .footer__icons {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }

  .footer__icons > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .footer__icons img {
    height: 16px;
  }
`;

export default disclaimer;
